var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar1080X108003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    enableBackground: "new 0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.74,
    fill: "#FF3614",
    width: 1080,
    height: 1080
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M758.85,478.43v146.58l-92.58-113.57l-84.97,30.44l-32.59,126.06l-41.03-99.42l-58.69,20.81 c-6.96-95.38-115.06-129.63-115.06-195.93c0-24.08,16.47-41.86,36.81-41.86c17.78,0,30.44,15.22,33,25.39l43.11-15.22 c-7.61-40.61-43.11-62.14-76.11-62.14c-40.61-1.25-90.09,34.25-90.09,93.89c0,96.39,114.17,131.95,114.17,210.56 c0,30.44-13.97,49.47-33,49.47c-25.39,0-36.81-31.69-36.81-67.25l-44.42,15.22c0,73.56,43.11,101.5,82.47,101.5 c43.76,0,74.92-27.83,83.72-75.16v171.55l40.61-13.97V622.51l50.72,129.87l31.69-8.86L616.74,575v163.46l40.61-13.97v-44.66 l70.82-26.22l28.13,35.38l43.11-15.22V464.46L758.85,478.43z M657.35,642.97v-78.49l48.4,60.95L657.35,642.97z M559.71,535.52 l14.15-38.65l55.66-19.8v34.37l40.61-13.97v-71.89l20.87-7.37l51.44,52.62l49.47-17.78l-21.58-19.03 c-25.27-21.64-33.42-27.35-45.01-32.17c16.11-13.38,29.79-32.17,29.79-65.47c0-41.86-25.39-68.5-81.17-49.47l-73.67,25.33 l-90.03,241L559.71,535.52z M681.49,332.51c20.28-7.61,30.44,1.25,30.44,16.47c0,15.22-6.36,24.08-27.89,33l-13.97,5.35v-50.42 L681.49,332.51z M629.46,344.7v96.09l-40.2,13.85L629.46,344.7z M403.68,383.29l187.72-67.25l-21.58,57.08l-68.5,24.02v159.9 l-40.61,13.97V410.82l-57.08,20.63v-48.16H403.68z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1080X108003);
export default __webpack_public_path__ + "static/media/Star1080x1080-03.c3a0f1e676719cd0d6fb39dc112447cd.svg";
export { ForwardRef as ReactComponent };